import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import frCommon from '../locales/fr/common.json';

const resources = {
  en: { common: enCommon },
  fr: { common: frCommon },
};

const SUPPORTED_LANGUAGES = ['en', 'fr'];
const DEFAULT_LANGUAGE = 'en';

// Detect lang from URL (?lang= or ?lng=)
const searchParams =
  typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const urlLang = searchParams?.get('lang') || searchParams?.get('lng');

// Only use URL lang if it's a supported language, otherwise use default
const initialLang = urlLang && SUPPORTED_LANGUAGES.includes(urlLang) ? urlLang : DEFAULT_LANGUAGE;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang, // explicit URL param has priority (bypasses detector)
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    load: 'languageOnly', // Load only 'fr' not 'fr-FR'
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
    returnEmptyString: false, // If translation is empty, fallback to fallbackLng
    returnNull: false, // If translation is null, fallback to fallbackLng
  });

export default i18n;
